<tmo-plan-sub-title
  [browsePlanAemContent]="aemContent"
  [selectedFamilyId]="planFamilyDetails?.familyId"
  (onMonthSelection)="handleRadioClickEvent($event)"
  (plansFiltertedByDuration)="getPlansByDuration($event)"
  [planOptions]="planOptions"
  [hidePlansHeader]="true"
></tmo-plan-sub-title>

<div id="panelGroup" class="m-t-xxl">
  <div class="panel-group" id="plan-section">
    <div
      *ngFor="let plan of plansByDuration; let idx = index"
      class="col-xs-12 col-md-12 col-lg-3 plan-block col-margin-limited-data relative"
      id="block"
      [ngClass]="planSelectedId === plan?.planOptionSelectorId ? 'highlight-border' : ''"
    >
      <div
        [ngClass]="
          planSelectedId === plan?.planOptionSelectorId ? 'highlight-plan' : 'plan-checked'
        "
      >
        <p class="selected-plan">{{ aemContent?.youSelectedThisPlan }}</p>
      </div>

      <div class="panel panel-default" id="plan-details">
        <div class="panel-heading">
          <tmo-plan-promotion-header
            [promotionTagIconTemplate]="promotionTagIconTemplate"
            [planPromotions]="planPromotions"
            [planId]="plan?.planOptionSelectorId"
            [isCPS]="isCPS"
          ></tmo-plan-promotion-header>
        </div>
        <div class="panel-body">
          <div class="plan-panel-heading">
            <p class="data-limit m-t-xs">{{ plan?.label }}</p>
          </div>
          <div class="price-section">
            <p class="plan-price m-t-md">
              {{ plan?.monthlyPrice?.displayValue | currency: 'USD' : 'symbol'
              }}<span>/{{ aemContent?.month }}</span>
            </p>
            <ng-container *ngIf="pricingDisclaimer; else defaultDisclainer">
              <p class="plan-desc m-t-xs">{{ pricingDisclaimer }}</p>
            </ng-container>
            <ng-template #defaultDisclainer>
              <p class="plan-desc m-t-xs">
                {{ aemContent?.forOnePhoneLine }} + {{ aemContent?.taxesAndChanges }}
              </p>
            </ng-template>
          </div>
          <ng-container *ngIf="aemContent && showAutoPayDiscountContent">
            <tmo-autopay-discount [content]="aemContent?.autopayDiscountContent" [planOption]="plan" (openInfoModal)="toggleAutopayDiscountDetailsModal($event)"/>
          </ng-container>
          <div class="includes-section">
            <p class="features m-t-lg">{{ aemContent?.includesLabel }}</p>
            <p class="m-t-lg m-b-md" id="subList1" [innerHTML]="plan?.shortDescription | safeHtml"></p>
          </div>
          <!-- Commented below code as we are not receiving this flag from backend and these fields will not be calculated at UI end -->
          <!-- <p class="plan-desc m-t-xl" *ngIf="showPrepay">{{prepayText}}</p>
                            <p class="plan-desc m-t-xl m-b-lg" *ngIf="showPrepay">({{plan?.monthlyPrice?.displayValue*12 | currency:'USD':'symbol'}} {{forMonths}})</p> -->
          <div class="btn-section">
            <a
              class="plan-detail-link m-t-xl"
              attr.aria-label="PlanDetails ' Hyperlink'"
              (click)="showPlanDetailsModal(plan)"
              >{{ aemContent?.planDetails }} <i class="fa fa-angle-right"></i
            ></a>
            <button
              *ngIf="planSelectedId !== plan?.planOptionSelectorId"
              class="btn btn-primary m-lg"
              id="selectPlan"
              (click)="updateSelectedPlan(plan)"
            >
              {{ aemContent?.selectPhonePlan }}
            </button>
            <button
              *ngIf="isProductSelector && planSelectedId === plan?.planOptionSelectorId"
              class="btn btn-primary m-lg"
              id="returnToCart"
              (click)="goToCart()"
            >
              {{ aemContent?.returnToCart }}
            </button>
            <button
              *ngIf="!isProductSelector && planSelectedId === plan?.planOptionSelectorId"
              class="btn btn-primary m-lg"
              id="returnToCart"
            >
              {{ aemContent?.selectedPhonePlan }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="fccLabelLinkText && fccLabelLinkUrl"
    class="text-magenta underline col-12 text-center m-b-lg p-t-md p-b-md"
  >
    <a class="f-w-700 f-s-16" href="{{ fccLabelLinkUrl }}" target="_blank">{{
      fccLabelLinkText
    }}</a>
  </div>
</div>
